


function setCodeDown(endTime: number) {
  localStorage.setItem('codeEndTime', JSON.stringify(endTime))
}

function getCodeDown() {
  return localStorage.getItem('codeEndTime')
}
function removeCodeDown() {
  localStorage.removeItem('codeEndTime')
}

function setSocConfigurable(config: string) {
  localStorage.setItem('SocConfigurable', config)
}

function getSocConfigurable() {
  return localStorage.getItem('SocConfigurable')
}
function removeSocConfigurable() {
  localStorage.removeItem('SocConfigurable')
}

function setProfileName(name: string) {
  localStorage.setItem('ProfileName', name)
}

function getProfileName() {
  return localStorage.getItem('ProfileName')
}


function setEmailAddress(email: string) {
  localStorage.setItem('EmailAddress', email)
}

function getEmailAddress() {
  return localStorage.getItem('EmailAddress')
}

function setPlatformName(name: string) {
  localStorage.setItem('PlatformName', name)
}

function getPlatformName() {
  return localStorage.getItem('PlatformName')
}

function clearStoreMarkData() {
  localStorage.setItem("storeMarkData", "");
  localStorage.removeItem("storeMarkData")
}

function setStoreMarkData(data: any) {
  clearStoreMarkData()
  localStorage.setItem("storeMarkData", JSON.stringify(data));
}


function getStoreMarkData() {
  const data = localStorage.getItem("storeMarkData")
  if (data) {
    const jsonData = JSON.parse(data!)
    return jsonData
  }
  return null
}

function setPreReportContent(data: any) {
  localStorage.setItem("PreReportContent", JSON.stringify(data))
}

function getPreReportContent() {
  const data = localStorage.getItem("PreReportContent")
  if (data) {
    const jsonData = JSON.parse(data!)
    return jsonData
  }
  return null
}

function clearPreReportContent() {
  localStorage.setItem("PreReportContent", "");
  localStorage.removeItem("PreReportContent")
}

function clearAllStorage() {
  localStorage.clear()
}

export {
  setCodeDown,
  getCodeDown,
  removeCodeDown,
  setSocConfigurable,
  getSocConfigurable,
  removeSocConfigurable,
  setProfileName,
  getProfileName,
  setEmailAddress,
  getEmailAddress,
  setPlatformName,
  getPlatformName,
  setStoreMarkData,
  getStoreMarkData,
  clearStoreMarkData,
  clearAllStorage,
  setPreReportContent,
  getPreReportContent,
  clearPreReportContent
}